{
    "routes": {
        "home": "Speechki — AI-generated audiobooks",
        "login": "Sign In",
        "profile": "Author Profile",
        "contract": "Publishing Contract",
        "upload": "Upload Book",
        "publish": "Publish Audiobook",
        "editor": "{title} — Speechki Editor",
        "contacts": "Contacts",
        "unavailable": "Site Is Under Maintenance",
        "contracted": "Contracted Books",
        "podcasts": "Podcasts"
    },
    "support": {
        "tooltip": "Send message to support. We answer Mon-Fri from 6:00 to 17:00 (GMT 3).",
        "answer": "We answer Mon-Fri from 6:00 to 17:00 (GMT 3).",
        "ideabutton": "Have an Idea?",
        "ideasend": "Send Us Your Idea",
        "send": "Contact support",
        "label": "Message",
        "placeholder": "Your message",
        "success": "We've got your message. The answer will be sent to the email specified in your account.",
        "email": "Our Email:",
        "faq": "Check out FAQ"
    },
    "booksList": {
        "title": "My Books",
        "upload": "Upload book",
        "searchPlaceholder": "Enter book title, author name or ISBN",
        "publishDate": "Publish date",
        "unpublished": "Not published",
        "narrator": "Narrator",
        "size": "Size",
        "authorUnknown": "Unknown Author",
        "editTooltip": "Edit book data",
        "nobooks": "You have no books yet. Create your first audiobook with Speechki!",
        "tutorial": "How to create a book",
        "notfound": "No books found",
        "noCategory": "None",
        "faq": "Check out FAQ"
    },
    "deleteBook": {
        "title": "Your book is going to be deleted",
        "text": "Book «{name}» is going to be deleted. Recovery will be impossible. Remove anyway?",
        "delete": "Remove"
    },
    "confirmModal": {
        "ok": "OK",
        "cancel": "Cancel"
    },
    "editor": {
        "goToSettings": "Go to book settings",
        "contents": {
            "title": "Contents",
            "chapters": "Chapters",
            "toggleChapters": "Toggle chapters",
            "notice": "Select chapters in the editor to see contents of your book.",
            "step1": "Choose a sentence",
            "step2": "Press the “settings” button",
            "step3": "Choose the “Chapter title” type",
            "step4": "Congrats! All done.",
            "sectionDuration": {
                "ok": "This chapter file size is correct. (< 4gb). <br> Size: {size}gb <br> Duration: {duration}",
                "notOk": "This chapter file size exceded maximum size (4gb). <br> Size: {size}gb <br> Duration: {duration}min <br> Chapter needs to be split into parts.",
                "firstChapterError": "Text between title and first chapter excedes maximum size (4gb). <br> Chapter needs to be split into parts.",
                "beforeChapter": "Text before chapters"
            }
        },
        "text": {
            "prev": "Previous part",
            "next": "Next part",
            "pagination": "Page {n} of {size}",
            "gotopage1": "Go to",
            "gotopage2": "",
            "gotopagego": "Go",
            "tipLeftClick": "LEFT CLICK to select sentence in editor",
            "tipRightClick": "RIGHT CLICK to select sentence options",
            "pageLabel": "Page",
            "pageOf": "of {total}",
            "pageInput": "Page number",
            "matchCount": "no matches | {n} match | {n} matches",
            "matchPosition": "{current} of {total}",
            "noMatches": "No matches",
            "matchListTitle": "{count} for “{query}”",
            "matchListHint": "Click a match to jump to it",
            "matchLocation": "Page {page} · Sentence {sentence}",
            "matchLocationPage": "Page {page}",
            "showAllMatches": "Show all matches",
            "seeAllComments": "See all comments",
            "prevMatch": "Previous match",
            "nextMatch": "Next match",
            "prevPage": "Previous page",
            "nextPage": "Next page"
        },
        "toolbar": {
            "generating": "Generating audio",
            "commonSettings": "Entire Sentence Settings",
            "weRecommend": "We recommend",
            "noVoices": "No available voices",
            "pickVoice": "Please select voice",
            "backButton": "Back to sentence settings",
            "wordSettings": "Word settings",
            "save": "Save",
            "cancel": "Cancel",
            "switchPlayer": "Waveform player",
            "copyLink": "Copy link",
            "copyText": "Copy text",
            "copyLinkSuccess": "Link copied",
            "copyTextSuccess": "Text copied",
            "isSample": "Sample",
            "suggestion": "Suggestion",
            "dictionary": "Dictionary",
            "specialSymbols": "Special symbols",
            "phonemes": "Phonemes",
            "emotion": "Emotion"
        },
        "ssml": {
            "modes": {
                "visual": "Visual editor",
                "source": "Source"
            },
            "phoneme": {
                "label": "Phoneme",
                "placeholder": "Select phoneme",
                "enter": "+ Enter manually",
                "title": "Phoneme Builder",
                "inputPlaceholder": {
                    "syllable": "Enter syllable",
                    "word": "Enter word"
                }
            },
            "sub": "Replace with",
            "say-as": "Say as",
            "emphasis": "Emphasis",
            "stress": "Stress",
            "prosody": {
                "pitch": "Pitch",
                "volume": "Volume",
                "rate": "Rate"
            },
            "mstts:express-as": {
                "style": "Style",
                "styledegree": "Style degree"
            },
            "tip": "You can use Ctrl or Shift to select multiple",
            "selectAll": "Select all"
        },
        "postproduction": "Post-production",
        "crmOrderState": {
            "text": "Are you sure you want to <b>{destination}</b>?",
            "cancel": "Cancel",
            "success": "Done!",
            "successText": "Orders state changed successfully",
            "error": "Changing state",
            "errorText": "Please try again later",
            "orderCompleted": "Order completed",
            "orderCompletedMessage": "You can't edit this book anymore"
        },
        "glueSentences": {
            "title": "Merge Sentences",
            "notice": "Are you sure you want to merge sentences? All of the settings previously applied to these sentences will be erased, i.e. phonemes, pauses, and stresses.",
            "newSentence": "New sentence:",
            "merge": "Merge",
            "state": {
                "merging": "Merging sentences..",
                "generating": "Generating sentences.."
            }
        },
        "suggestion": {
            "title": "Pronunciation Potential Errors",
            "noData": "No Pronunciation Potential Errors",
            "isCompleted": "Completed",
            "errorFound": "Error found",
            "filter": {
                "all": "All",
                "isCompleted": "Completed",
                "unCompleted": "Uncompleted"
            },
            "childs": {
                "highlight": "Mark Pronunciation Potential Errors",
                "goto": "Go to Pronunciation Potential Errors"
            }
        },
        "brokenParts": {
            "menuItem": "Broken parts",
            "noData": "No broken parts. Everything seems alright!"
        },
        "shuffle": {
            "menuItem": "Shuffle",
            "title": "Shuffled parts of the book",
            "noData": "No suggestions yet"
        },
        "dictionary": {
            "title": "Dictionary",
            "form": {
                "sourceLabel": "Source text",
                "sourcePlaceholder": "Enter a phrase",
                "replaceLabel": "Replacement",
                "replacePlaceholder": "Enter a replacement",
                "providerLabel": "Provider"
            }
        },
        "specialSymbols": {
            "title": "Special symbols",
            "form": {
                "sourceLabel": "Source text",
                "sourcePlaceholder": "Enter a symbol",
                "replaceLabel": "Replacement",
                "replacePlaceholder": "Enter a replacement",
                "providerLabel": "Provider"
            }
        },
        "phonemes": {
            "title": "Phonemes",
            "form": {
                "title": "Creating a phoneme",
                "keyLabel": "Word",
                "keyPlaceholder": "Enter the word",
                "valueLabel": "Phoneme",
                "valuePlaceholder": "Enter the phoneme"
            }
        }
    },
    "textsearch": {
        "placeholder": "Search text",
        "showAll": "Show all results"
    },
    "textEntityControl": {
        "delete": "Delete sentence",
        "play": "Play from sentence",
        "textType": "Text type",
        "addCorrection": "Edit this sentence",
        "leaveComment": "Leave a comment"
    },
    "pause": {
        "pause": "Pause",
        "duration": "Duration (ms)",
        "applyToAll": "Apply to",
        "pauses": "pauses between sentences",
        "paragraphEnds": "paragraph endings",
        "bumpTitle": "Replace with audio",
        "settingsTitle": "Pause settings",
        "bump": {
            "remove": "Remove",
            "audio": "Audio",
            "placeholder": "Choose an audio file",
            "empty": "No audio files"
        },
        "pause_configs": {
            "title": "Pause configs"
        }
    },
    "misc": {
        "send": "Send",
        "profile": "Profile",
        "logout": "Log out",
        "settings": "Settings",
        "download": "Download",
        "editor": "Editor",
        "delete": "Delete",
        "language": "Language",
        "category": "Category",
        "publish": "Publish",
        "lastChange": "Changed",
        "trialVersion": "Trial version",
        "save": "Save",
        "type": "Type",
        "speed": "Speed",
        "volume": "Volume",
        "voice": "Voice",
        "effect": "Effect",
        "select": "Select",
        "word": "Word",
        "phoneme": "Phoneme",
        "loadmore": "Load more",
        "notfound": "Not found",
        "example": "Example",
        "enterText": "Text",
        "author": "Author",
        "back": "Back",
        "name": "Name",
        "lastName": "Last name",
        "firstName": "First name",
        "patronymic": "Patronymic",
        "dateOfBirth": "Date of birth",
        "phoneNumber": "Phone number",
        "pseudonym": "Pseudonym",
        "pseudonymes": "Pseudonymes",
        "description": "Description",
        "loading": "Loading",
        "toBookList": "Back to book list",
        "apply": "Apply",
        "edit": "Edit",
        "status": "Status",
        "sentence": "Sentence",
        "error": "Error",
        "add": "Add",
        "date": "Date",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "close": "Close",
        "token": "Token",
        "done": "Done",
        "search": "Search",
        "anonimous": "Anonimous",
        "selectAll": "Select all",
        "unselectAll": "Unselect all",
        "continue": "Continue",
        "reply": "Reply",
        "replies": "Replies",
        "refresh": "Refresh"
    },
    "trialNotice": {
        "popupContent": "<h4>Listen to a piece of your audiobook!</h4><ol><li>Click the «Download Book» button</li><li>In the opened window click on «Run build proccess»</li><li>Wait for build to complete</li><li>Listen to the audiofile or download it for free</li></ol>",
        "okay": "OK",
        "youUseFree": "You are using free version of audiobook editor",
        "text": "Only <b>10 first sentences</b> have been recorded. To record the entire book, purchase a paid tariff worth ${price} per thousand characters.",
        "voice": "Record"
    },
    "export": {
        "title": "Download Audiobook",
        "downloadAudiobook": "Download audiobook",
        "trial": "You're building a trial book. Only 10 first sentences will be available.",
        "buildNew": "Build new",
        "runBuild": "Run build process",
        "types": {
            "metaStorytel": "Download Storytel meta",
            "metaBookmate": "Download Bookmate meta",
            "storytelArchive": "Storytel archive",
            "bookmateArchive": "Bookmate archive",
            "download": "Download"
        },
        "playerNotice": "Build book as one file to listen to it",
        "notice": "You can download your audiobook and start distributing it yourself right now!",
        "repair": {
            "title": "Empty sentences found!",
            "forExample": "Example",
            "total": "Total: 0 sentences | Total: {n} sentence | Total: {n} sentences",
            "notice": "If you build the book now, some of the sentences will be missed. Continue still?",
            "export": "Build",
            "checking": "Checking book for errors",
            "preparing": "Getting book ready",
            "openInEditor": "Open in Editor",
            "backToBookEditing": "Back to whole book editing"
        },
        "status": {
            "actual": "Actual build",
            "old": "Outdated build",
            "missing": "No build",
            "progress": "In progress",
            "check": "Checking book for errors",
            "repair": "Getting book ready",
            "build": "Building...",
            "brokenParts": "Broken parts in the book"
        },
        "singleFileLoader": "Building book as single file takes about 5 minutes",
        "archiveLoader": "Building a 4-hour book usually takes 20 minutes",
        "pleaseWait": "Please wait. We are building your book",
        "ready": "Audiobook is ready",
        "type": "Format",
        "bookNotActual": "The book has been changed. The audio you are listening to isn't relevant",
        "authorOptions": {
            "excludeAuthor": "Exclude the author's name",
            "excludeTitle": "Exclude the Title",
            "excludeAuthorAndTitle": "Exclude the author's name and title",
            "fullText": "Full Text"
        }
    },
    "bookEdit": {
        "title": "Book Settings",
        "bookTitle": "Title",
        "saveTitleTooltip": "Save title",
        "editTitleTooltip": "Edit title",
        "originalTitle": "Original Title",
        "ageRating": {
            "type": "Age rating country",
            "label": "Age rating"
        },
        "cover": "Cover",
        "generate": "Generate",
        "coverReqs": "Cover requirements: <b>JPEG format, 640x640 size</b>.",
        "playerLabel": "Your audiobook",
        "category": {
            "add": "+ Add category",
            "empty": "Please select at least one category",
            "modalTitle": "Select categories"
        },
        "translator": "Translator",
        "translatorPlaceholder": "Translator name",
        "description": "Book description",
        "descriptionPlaceholder": "Enter book description",
        "save": "Save book",
        "size": "k characters",
        "document": "Download book text"
    },
    "personages": {
        "select": {
            "placeholder": "Change role"
        },
        "manager": {
            "trigger": "Edit roles",
            "title": "Manage roles",
            "add": "Add a role"
        },
        "delete": {
            "title": "Deleting a role"
        },
        "list": {
            "name": "Role",
            "namePlaceholder": "Role name",
            "speaker": "Voice"
        }
    },
    "upload": {
        "title": "Upload Book",
        "format": "(only .docx files)",
        "fileLabel": "Press to upload DOCX file",
        "rules": "How to prepare and upload a book",
        "name": "Title",
        "upload": "Upload",
        "selectLanguage": "Please select language first",
        "noAuthors": "No authors",
        "authorData": "Your profile",
        "rightsNotice": "This is necessary to protect your copyrights.",
        "lastNamePlaceholder": "Musk",
        "firstNamePlaceholder": "Peter",
        "patronymicPlaceholder": "",
        "willPublish": "I plan to sell my book in stores",
        "pseudonymNotice": "I write under my own name",
        "tariffs": "This voice is available in highlited packages",
        "freeTariff": "Not for publishing for sale",
        "notice": "Processing of the complete book with selected voice is calculated according to the package that includes selected voice.",
        "tariffPrice": "{price} {currency}/1000 char",
        "iHaveIsbn": "I have an ISBN",
        "titlePlaceholder": "Alice in Wonderland",
        "stayConfidential": "Stay confidential for now",
        "fillProfile": "Fill my profile",
        "stayConfidentialNotice": "You've preferred to stay confidential",
        "addPseudo": "+ Add a pseudonym",
        "copyrightHolder": "Copyright holder",
        "speed": "Reading speed"
    },
    "profile": {
        "title": "Profile",
        "emptyData": "Fill all required fields to continue working with the service. This is necessary to verify your identity and protect your copyrights.<br />Required fields are marked with * symbol.",
        "personalData": "Personal Info",
        "contactData": "Contact Info",
        "address": "Address",
        "postalAddress": "Postal address",
        "otherData": "Other Info",
        "site": "Website",
        "aboutme": "About me",
        "iAgreeWith": "I agree with",
        "termsOfService": "terms of service",
        "security": "Security",
        "changePassword": "Change password",
        "newPass": "New password",
        "confirmPass": "Confirm password",
        "export": "Export",
        "exportingUsers": "Exporting Users",
        "exportingBooks": "Exporting Books",
        "tabs": {
            "profile": "Profile",
            "pseudonymes": "Pseudonymes",
            "security": "Security",
            "export": "Export",
            "projects": "Projects"
        },
        "customersEmployeesMembership": "Employees",
        "customersMembersMembership": "Customers"
    },
    "payment": {
        "title": "Purchase",
        "type": "Type",
        "voicing": "Book voicing",
        "promocode": "Promo Code",
        "symbols": " characters",
        "total": "Total",
        "pay": "Purchase",
        "thanks": "Thank you for your purchase!",
        "successNoLimit": "If you have successfully paid for the voicing of one book, voicing of the book will start automatically immediately after the payment is received in our account. <br /> It usually takes from 1 minute to 1 hour.",
        "haveQuestions": "Have questions? Contact us",
        "successPayment": "Successful payment!",
        "thankYou": "Thank you for using our service. The robot is voicing your book.",
        "useEditor": "Voicing process does not interfere editing process. You can keep working! <br /> As soon as the process is completed, you can download your audiobook as a one file or by chapters according to book's table of contents.",
        "redirect": "Redirecting you to payment page",
        "packages": "Voice package",
        "ok": "OK",
        "perhour": "per hour",
        "plans": {
            "title": "Plans and Prices"
        },
        "help": {
            "common": "Attention! You can't change the voice after purchase. You’ll be able to change the voice for each sentence in the book.",
            "noStress": "Attention! This voice doesn't allow stress changing.",
            "priceSymbolsNotice": "The cost is calculated based on the volume of your book and the cost per 1000 characters. "
        }
    },
    "login": {
        "signIn": "Sign In",
        "signUp": "Sign Up",
        "email": "Your Email",
        "password": "Your password",
        "showPass": "Show password",
        "confirmPass": "Confirm password",
        "haveAnAccount": "Have an account? Sign in",
        "agreement": "Joining up, I agree with",
        "terms": "terms of service",
        "reset": {
            "trigger": "Forgot password",
            "title": "Reset Password",
            "request": "Send password reset email",
            "linkSent": "We've send you a link to password reset. Check your email {email}.",
            "submit": "Change password",
            "password2": "Confirm password"
        }
    },
    "contract": {
        "title": "Audiobook publishing contract",
        "current": "Current contract",
        "fulltext": "Read full text",
        "status": "Status",
        "statuses": {
            "actual": "Signed (Latest version)",
            "old": "Signed (Old version)",
            "draft": "Draft",
            "moderate": "On moderation",
            "expired": "Expired",
            "canceled": "Canceled"
        },
        "dateCreated": "Created",
        "dateEnd": "End date",
        "autoRenewal": "Auto-renewal",
        "off": "Off",
        "on": "On",
        "turnOff": "Turn off",
        "stopRenewalNotice": "Contract auto-renewal will be stopped",
        "newVersionAvailable": "New version available",
        "signNew": "Resign contract",
        "newVersion": "Latest version contract",
        "comments": "Moderation comments",
        "sign": "Sign",
        "citizenship": "Citizenship",
        "confirmData": "Confirm personal data",
        "editData": "Edit information",
        "checkData": "Check personal information",
        "verifyData": "Verify personal information"
    },
    "massReplacement": {
        "trigger": "Find and replace everywhere in the text",
        "title": "Find and replace",
        "target": "Find what: ",
        "replacement": "Replace with: ",
        "position": "{n} of {total}",
        "diffSwitch": "Display replacement",
        "buttons": {
            "replace": "Replace",
            "replaceAll": "Replace all",
            "previous": "Previous",
            "next": "Next",
            "fullList": "View full list"
        },
        "success": "Modified sentences have been recorded anew.",
        "generation": "Generation: {n}/{total}"
    },
    "bookPartsChanges": {
        "menuItem": "History of changes",
        "title": "History of changes",
        "backToBookEditing": "Back to whole book editing",
        "results": {
            "initText": "Initial text",
            "currentText": "Current text",
            "noData": "No changes yet"
        }
    },
    "symbolsRemainder": {
        "forAdjustments": "For adjustments",
        "generationTooltip": "Each new sentence generation deducts from this value the number of sentence characters",
        "unlimited": "You can do ulimited adjustments",
        "youHave": "For adjustments",
        "forAjustmentsEnd": "",
        "and": "and",
        "limitReached": "You have reached the limit for adjustments.",
        "support": "Contact support and we will solve this issue individually.",
        "inTouch": ""
    },
    "pseudonymPicker": {
        "add": "+ Add pseudonym",
        "title": "New Pseudonym",
        "edit": "Edit Pseudonym",
        "description": "Description"
    },
    "errors": {
        "generationError": "Error occured"
    },
    "docsDropdown": {
        "tutorial": "Tutorial",
        "terms": "Terms of Service",
        "rules": "Rules",
        "payment": "Payment and returns",
        "prepareBook": "How to prepare a book",
        "contracts": "Audiobook publishing contracts"
    },
    "bookReload": {
        "title": "Reupload book",
        "notice": "All book's contents will be replaced",
        "button": "Upload"
    },
    "currency": {
        "currency": "Currency"
    },
    "adminBookControls": {
        "title": "Manage book",
        "addContractor": "Add contractor",
        "noContractors": "No contractors",
        "book": "Book",
        "contractor": "Contractor",
        "contractors": "Contractors",
        "published": "Published",
        "notPublished": "Not published",
        "sendFtp": "Transfer book",
        "sendMeta": "Send meta",
        "status": "Status",
        "ftpSuccess": "Book sent",
        "metaSuccess": "Metadata sent",
        "success": "Success",
        "errorFtp": "Transfer error",
        "buildType": "Build type"
    },
    "tutorial": {
        "next": "Next",
        "prev": "Prev",
        "finish": "Finish",
        "skip": "Skip",
        "of": "of"
    },
    "dateRange": {
        "dateStart": "Start date",
        "endDate": "End date",
        "clear": "Clear",
        "apply": "Apply"
    },
    "partsPlayer": {
        "length": "Page {page}/{total}, sentence {cur}/{size}",
        "lengthReviewer": "Page {page}/{total} · Sentence {cur}/{size}",
        "pause": "Pause",
        "sec": "sec",
        "bump": "Audio bump",
        "try": "Try out new player!",
        "old": "Use old player",
        "loadingPage": "Loading page {number}",
        "playing": "Playing",
        "paused": "Paused",
        "play": "Play",
        "pauseAction": "Pause",
        "prevSentence": "Previous sentence",
        "nextSentence": "Next sentence"
    },
    "sentenceSplitter": {
        "splitOn2": "Split into two",
        "splitSentence": "Split sentence",
        "split": "Split",
        "selectPoint": "Select a point of division",
        "oneWord": "There's only one word in this sentence, we can't split it",
        "warning": "All the settings you've applied will be erased, i.e. phonemes, pauses, and stresses",
        "loading": "Splitting the sentence"
    },
    "textPagination": {
        "paymentNotice": "Navigation between pages will be available after you purchase this book",
        "goTo": "Go to page"
    },
    "corrections": {
        "title": "Corrections",
        "add": {
            "title": "Create correction",
            "comment": "Comment",
            "commentPlaceholder": "Use this field to enter your pronunciation change request.\nHere are examples of how you must submit these:\n\nPhiladelphia = Filahdelfeeuh\nVeronica = Vraanuhkuh\nVolleyball = vaaleebaal",
            "parent": "Parent correction",
            "empty": "No corrections",
            "save": "Save",
            "cancel": "Cancel",
            "success": "Correction was successfully created"
        },
        "list": {
            "empty": "Congratulations! All of your updates are approved.  If you don't wish to make any further changes, please submit your final approval",
            "reviewerEmptyTitle": "No corrections",
            "reviewerEmptyHint": "Hover any sentence in the audiobook and choose \u201cLeave a comment\u201d to request a change.",
            "backToBookEditing": "Back to whole book editing"
        },
        "item": {
            "title": "Correction №",
            "saved": "Correction saved",
            "statusError": "Status change error",
            "tryAgain": "Please try again later",
            "createChild": "Create child correction",
            "viewInBook": "View in book",
            "addComment": "Add comment",
            "writeYourComment": "Write your comment…"
        },
        "report": {
            "get": "Download report",
            "error": "Error generating report"
        },
        "player": {
            "play": "Play audio",
            "pause": "Pause audio",
            "mute": "Mute audio",
            "unmute": "Unmute audio",
            "progress": "Audio progress"
        },
        "delete": {
            "trigger": "Delete this correction",
            "title": "Delete correction",
            "warning": "If it has <b>child corrections</b> they will be deleted!",
            "content": "Are you sure you want to delete this correction?"
        }
    },
    "notes": {
        "add": {
            "title": "Add a note",
            "commentPlaceholder": "Enter",
            "empty": "No notes",
            "save": "Save",
            "cancel": "Cancel",
            "success": "Note was successfully created"
        },
        "item": {
            "title": "Edit note",
            "success": "The note was saved successfully"
        },
        "list": {
            "empty": "No notes"
        },
        "delete": {
            "trigger": "Delete note",
            "title": "Delete note",
            "content": "Do you want to delete the note?",
            "warning": "The note will be deleted"
        },
        "build": {
            "label": "Export notes:",
            "download": "Download notes",
            "create": "Refresh build",
            "error": "Build error",
            "time": "rebuilded at",
            "status": {
                "building": "Building..."
            }
        },
        "subtitles": {
            "label": "Subtitles:",
            "download": "Download"
        },
        "router": {
            "text": "View all notes"
        }
    },
    "podcasts": {
        "title": "Podcasts",
        "create": "Create",
        "delete": {
            "title": "Delete podcast",
            "text": "Do you want to delete podcast "
        },
        "card": {
            "explicit": "Explicit"
        },
        "detail": {
            "editPodcast": "Edit podcast",
            "cancelEditing": "Cancel editing",
            "name": "Podcast Name",
            "rss": "RSS feed URL",
            "email": "Contact Email",
            "author": "Author",
            "descr": "Description",
            "lang": "Language",
            "category": "Category",
            "isExplicit": "Contains explicit content",
            "isActive": "Active",
            "save": "Save",
            "delete": "Detele this podcast",
            "episodes": "Episodes",
            "editEpisodes": "Edit episodes",
            "created1": "You have successfuly created a podcast! Now you can",
            "created2": " to it.",
            "addLink": "add episodes",
            "success": "Podcast created"
        },
        "list": {
            "empty": "No Podcasts yet",
            "createOne": "Create one"
        },
        "copyFeed": "Copy feed URL",
        "copyFeedSuccess": "RSS feed URL copied",
        "episodes": {
            "empty": "No episodes yet.",
            "addEpisode": "+ Add episode",
            "notSelected": "You haven't selected episode",
            "detail": "Episode Detail",
            "type": "Episode type",
            "typeNotice": "What to be included in the podcast feed: full audio of the book, just the samples or both",
            "builds": "Book builds status",
            "hasBuild": "OK! Build exists",
            "nobuild": "No build! Please build book with corresponding build type",
            "buildsNotice": "Check if all the correct builds are ready.",
            "delete": "Delete episode",
            "book": "Book",
            "searchBook": "Book name, etc"
        },
        "category": {
            "trigger": "Change category"
        }
    },
    "samples": {
        "title": "Book samples",
        "clearSamples": "Clear all samples",
        "noSamples": "No samples. You can mark any sentence as sample in the book editor.",
        "confirm": "Are you sure you want to clear all book samples?",
        "clear": "Clear"
    },
    "crm": {
        "customers": {
            "title": "Customers",
            "list": {
                "name": "Name",
                "type": "Type",
                "hook": "Hook",
                "members": "Members",
                "empty": "No customers yet",
                "notFound": "No customers found"
            },
            "create": {
                "trigger": "Create a customer",
                "title": "Creating a customer"
            },
            "members": {
                "title": "Team Members",
                "list": {
                    "empty": "No team members",
                    "notFound": "Team members not found"
                },
                "add": {
                    "trigger": "Add team members",
                    "title": "Add team members"
                },
                "edit": {
                    "title": "Edit Customers Members"
                },
                "repeater": {
                    "trigger": "Add a team member"
                },
                "item": "no members | {n} member | {n} members | {n} member"
            },
            "invites": {
                "title": "Invites",
                "menuItem": "Invites",
                "results": {
                    "noData": "No invites"
                },
                "delete": {
                    "title": "Deleting invite",
                    "content": "The selected invite will be deleted. Do you want to continue?",
                    "success": "Invite have been deleted"
                },
                "acceptToJoin": {
                    "trigger": "Accept to join",
                    "title": "Accepting to join",
                    "content": "The selected invite will be accepted to join. Do you want to continue?",
                    "success": "Invite have been accepted to join"
                },
                "inviteLink": {
                    "trigger": "Copy to clipboard",
                    "success": "Copied!"
                }
            }
        },
        "employees": {
            "title": "Employees",
            "add": {
                "trigger": "Add an editor",
                "title": "Add an editor"
            },
            "edit": {
                "title": "Edit Employees"
            },
            "repeater": {
                "trigger": "Add Employee"
            },
            "item": "no employees | {n} employee | {n} employees | {n} employee"
        },
        "orders": {
            "title": "Orders",
            "list": {
                "title": "Title",
                "author": "Author",
                "voice": "Voice",
                "lastChange": "Last changed",
                "customer": "Customer",
                "type": "Type",
                "state": "Status",
                "empty": "You haven’t created any orders yet",
                "notFound": "No orders found",
                "create": "Create an order"
            },
            "export": {
                "button": "Export CSV",
                "error": "Failed to export orders",
                "tryAgain": "Please try again later"
            },
            "backButton": "Back to the order",
            "selectLanguage": "Please choose a language first",
            "selectCustomer": "Please select a customer first",
            "selectOrder": "Please select an order",
            "noSpeakers": "No speakers found"
        },
        "users": {
            "title": "Users",
            "list": {
                "id": "ID",
                "email": "E-mail",
                "name": "Name",
                "role": "Role",
                "customer": "Customer",
                "empty": "No users yet",
                "notFound": "No users found"
            },
            "delete": {
                "title": "Deleting users",
                "content": "The selected users will be deleted. Do you want to continue?",
                "success": "Users have been deleted"
            },
            "item": "no users | {n} user | {n} users | {n} user"
        },
        "tokens": {
            "title": "Tokens",
            "list": {
                "button": "Tokens",
                "name": "Name",
                "prefix": "Prefix",
                "empty": "No tokens yet",
                "notFound": "No tokens found"
            },
            "create": {
                "trigger": "Create token",
                "title": "Creating a token",
                "success": "The token was successfully created",
                "error": "A token creation error occurred"
            },
            "delete": {
                "title": "Deleting a token",
                "success": "The token has been deleted"
            },
            "clipboard": {
                "button": "Copy to clipboard",
                "hint": "Click to copy",
                "success": "Copied!"
            }
        },
        "authors": {
            "noData": "No authors yet",
            "manager": {
                "add": "Add an author"
            }
        },
        "notifications": {
            "page": {
                "title": "Notifications",
                "trigger": "View older notifications"
            },
            "clearAll": "Clear all",
            "noData": "No new notifications"
        },
        "stylesheet": {
            "menuItem": "Style sheet",
            "title": "Style sheet",
            "noData": "No rules yet",
            "noResults": "No rules found",
            "backButton": "Back to the customer",
            "results": {
                "id": "ID",
                "target": "Word / Name / Phrase",
                "explanation": "Pronunciation rule / Explanation"
            },
            "edit": {
                "title": "Editing a style rule"
            },
            "create": {
                "trigger": "Create style rule",
                "title": "Creating a style rule"
            },
            "delete": {
                "title": "Deleting a style rule",
                "content": "The selected rule will be deleted. Do you want to continue?",
                "success": "Rule have been deleted"
            }
        },
        "statistic": {
            "title": "Statistics",
            "menuItem": "Statistics",
            "noData": "No statistics yet",
            "noResults": "No statistics found"
        },
        "transitions": {
            "title": "Transitions",
            "menuItem": "Transitions",
            "backButton": "Back to transitions",
            "noData": "No transitions yet",
            "noResults": "No transitions found",
            "results": {
                "source": "Source",
                "dest": "Destination"
            },
            "graph": {
                "title": "Transitions graph",
                "create": {
                    "trigger": "Create a graph"
                }
            }
        },
        "defaultSpeakers": {
            "title": "Default speakers",
            "menuItem": "Default speakers",
            "results": {
                "noData": "No speakers yet",
                "noResults": "No speakers found"
            },
            "create": {
                "trigger": "Create a speaker",
                "title": "Creating a speaker"
            },
            "update": {
                "title": "Updating a speaker"
            },
            "delete": {
                "title": "Deleting a speaker",
                "success": "The speaker has been deleted"
            }
        }
    },
    "backgroundAudio": {
        "title": "Background audio",
        "form": {
            "label": "Name",
            "filePlaceholder": "Click to select an audio file"
        },
        "add": {
            "trigger": "Upload a file",
            "title": "Add background audio",
            "success": "Audio file was successfully created"
        },
        "edit": {
            "trigger": "Edit",
            "title": "Edit background audio",
            "success": "The audio file was saved successfully"
        },
        "delete": {
            "trigger": "Delete",
            "title": "Delete background audio",
            "content": "Are you sure you want to delete this background audio?",
            "success": "The audio file will be deleted"
        }
    },
    "bookparts": {
        "loading": "Please wait.",
        "noData": "No results yet",
        "partTitle": "Sentence"
    },
    "audioEditor": {
        "title": "Edit audio",
        "tips": {
            "idle": [
                "Press spacebar to play and pause",
                "Click right to play from chosen time",
                "Click left to select a fragment to edit"
            ],
            "creating": "Click again to select the end of the fragment",
            "completed": "Adjust timing for the fragment you want to edit",
            "reading": "Fragment {start}s : {end}s",
            "cutted": "@:audioEditor.tips.reading"
        },
        "actions": {
            "selectSegment": "Select fragment",
            "deleteSegment": "Delete fragment",
            "cutSegment": "Cut fragment",
            "uncutSegment": "Uncut"
        }
    },
    "booksBuilds": {
        "title": "Download",
        "edit": {
            "builderLabel": "Export:",
            "providerLabel": "Provider:",
            "typeLabel": "Type:",
            "speedLabel": "Speed:",
            "optionsLabel": "Options:",
            "optionsList": {
                "fullText": "Full text",
                "excludeTitle": "Exclude title",
                "excludeAuthor": "Exclude author's name",
                "excludeAuthorAndTitle": "Exclude title and author's name"
            },
            "submitButton": "Create files"
        },
        "list": {
            "title": "Builds",
            "noDataText": "No builds yet"
        },
        "error": {
            "invalid": "Invalid required fields"
        },
        "tips": {
            "trigger": "Book Build Manager",
            "checking": "Checking book for errors",
            "repairing": "Getting book ready",
            "building": "Building...",
            "completed": "The build is complete"
        },
        "emptyParts": {
            "title": "Voicing errors",
            "description": "Some sentences in the audiobook were not voiced correctly.",
            "actions": {
                "correct": "Correct errors",
                "repair": "Build with errors"
            }
        }
    },
    "stylesheet": {
        "menuItem": "Style sheet",
        "title": "Style sheet",
        "noData": "No results yet",
        "results": {
            "word": "Word / Name / Phrase",
            "explanation": "Pronunciation rule / Explanation"
        },
        "resultsShort": {
            "word": "Phrase: ",
            "explanation": "Explanation: "
        }
    },
    "comment": {
        "title": "Comments",
        "placeholder": "Comment"
    }
}
